export type ExpertSelectTypes = {
    expert: { value: number, label: string }|null;
  };
  
  export const ExpertSelectDefault: ExpertSelectTypes = {
    expert: null
  };